<script>
export const groupId = 'group-' + Math.random().toString(36).substring(2, 15)
</script>

<script setup>
import DefaultFull from '../../default/groups/Full.vue'
import Transition4 from '../transitions/Transition4.vue'

const props = defineProps({
  item: Array,
})

const endTransitionComponent = ref(null)
const { onDisappear } = useDisappearable()
onDisappear(async () => {
  await endTransitionComponent.value.start()
})
</script>

<template>
  <Transition4 ref="endTransitionComponent" manualStart direction="out">
    <DefaultFull v-bind="props" />
  </Transition4>
</template>
